<crm-single-select
  #singleSelectComponent
  [options]="operationTypes"
  [(selectedItem)]="_selectedOperationType"
  (selectedItemChange)="onSelect($event)"
  [label]="labelInput ? 'Вид операции' : ''"
  [virtualScroll]="true"
  [virtualScrollItemSize]="33"
  [showClear]="showClear"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  filterBy="name"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
